module.exports = __webpack_public_path__ + "img/clock.4b9a8be6.svg";